export default "__VITE_ASSET__4lUiosJ9__"